export default __webpack_public_path__ + "05770d24ab7e2cc707081d8b2540f5d1.png";